module.exports = __webpack_public_path__ + "static/img/logo05.a372f928.png";